import * as React from 'react'
import styles from './styles.module.css'

export const Page = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.centerBody}>{children}</div>
)
